"use strict";
var zip_1 = require('./zip');
function zipAll(project) {
    return function (source) { return source.lift(new zip_1.ZipOperator(project)); };
}
exports.zipAll = zipAll;
//# sourceMappingURL=zipAll.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/operators/zipAll.js
// module id = 459
// module chunks = 0